'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeTab = void 0;
const $ = require("jquery");
class ChangeTab {
    constructor() {
        // 「製品情報から知る」「技術情報から知る」のタブ切替
        $('.trigChangeTab').on('click', (e) => {
            const isOpen = $(e.currentTarget).attr('data-is-active');
            const contentType = $(e.currentTarget).attr('data-type');
            $('.trigChangeTab').attr('data-is-active', 'false');
            $('.bulletChangeContent').attr('data-is-active', 'false');
            if (isOpen === 'false') {
                $(e.currentTarget).attr('data-is-active', 'true');
                $(`.bulletChangeContent[data-type="${contentType}"]`).attr('data-is-active', 'true');
            }
        });
        // 「製造工程から知る」の技術タブ切替（他のスライドと連動しないように作成）
        $(document).on('click', '.trigChangeTechTab', (e) => {
            const clickedTab = $(e.currentTarget);
            const contentType = clickedTab.attr('data-tech-type');
            // クリックされたタブが属するスライド単位の親要素を取得
            const $slide = clickedTab.closest('.paramSwiperSlide');
            $slide.find('.trigChangeTechTab').attr('data-is-active', 'false'); // そのスライド内のタブだけをリセット
            $slide.find('.bulletChangeTechContent').attr('data-is-active', 'false'); // そのスライド内のコンテンツだけをリセット
            clickedTab.attr('data-is-active', 'true'); // クリックされたタブをアクティブに
            $slide.find(`.bulletChangeTechContent[data-tech-type="${contentType}"]`).attr('data-is-active', 'true'); // 対応するコンテンツをアクティブに
        });
    }
}
exports.ChangeTab = ChangeTab;
exports.default = ChangeTab;
